import { useEffect } from "react";
import { AiFillInstagram } from "react-icons/ai";
import { BsTwitter } from "react-icons/bs";
import { GrFacebook } from "react-icons/gr";
import { ImLinkedin } from "react-icons/im";
import "./ExploreMore.css";

// no significant changes here

function ExploreMore() {
  useEffect(() => {
    window.scrollTo(0,0)
  },[])
  return (
    <div className="overall-container">
      <div className="grid-container">
        <div className="grid-child-email">
          <div className="content-container">
            <div>
              If you have any further questions, feel free to contact us at
              <a href="mailto:info@GenerationSOS.org">
                {" "}
                info@GenerationSOS.org{" "}
              </a>
            </div>
            <div></div>
          </div>
        </div>

        <div className="grid-child">
          <div className="icons-container">
            <a href="https://twitter.com/generationsosus">
              <div className="icon-wrap">
                <BsTwitter size={70} color={"#1DA1F2"} />
              </div>
            </a>
            <div className="icon-wrap">
              <AiFillInstagram size={85} color={"#5B51D8"} />
            </div>
            <div className="icon-wrap">
              <ImLinkedin size={70} color={"#0077b5"} />
            </div>
            <div className="icon-wrap">
              <GrFacebook size={70} color={"#4267B2"} />
            </div>
          </div>
        </div>
      </div>

      <div className="advertisement-container">
        <div className="advertisement-content-container">
          If you want to learn more,
          <a className="link-styling" href="https://www.generationsos.org/">click here</a>
          to visit our website
        </div>
      </div>
    </div>
  );
}
export default ExploreMore;